import React, { useState } from "react";
import CategoryHeader from "../../../Components/Headers/CategoryHeader";
// import VerifyEKYC from '../EKYC/VerifyEKYC'
// import DocUpload from '../UploadDocument/DocUpload'
import FormCKYC from "./FormCKYC";

const VerifyCKYC = (props) => {
  const {
    CKYC,
    setCKYC,
    EKYC,
    setEKYC,
    setNext,
    decryptedResponseId,
    decryptedAcuvisor_product_id,
    productName,
    decryptedProductRef,
    a_id,
  } = props;

  return (
    <div>
      {productName === 12331 && productName === 12332 ? (
        <>HDFC</>
      ) : (
        <FormCKYC
          CKYC={CKYC}
          setCKYC={setCKYC}
          EKYC={EKYC}
          setEKYC={setEKYC}
          setNext={setNext}
          decryptedResponseId={decryptedResponseId}
          decryptedAcuvisor_product_id={decryptedAcuvisor_product_id}
          decryptedProductRef={decryptedProductRef}
          a_id={a_id}
        />
      )}
    </div>
  );
};

export default VerifyCKYC;
